module.exports = __webpack_public_path__ + "static/img/dxxq.d60eee6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dxxq.jpg
// module id = ZHep
// module chunks = 1